// material ui icons
import LocalOfferRoundedIcon from '@mui/icons-material/LocalOfferRounded';

// material ui
import { Chip } from '@mui/material';
import type { ChipProps } from '@mui/material';

interface UnitTagProps {
  label: string;
  sx?: ChipProps['sx'];
}

const UnitTag = ({ label, sx }: UnitTagProps) => {
  return (
    <Chip
      icon={<LocalOfferRoundedIcon fontSize="small" />}
      label={label}
      size="small"
      sx={[
        {
          borderRadius: 1,
          backgroundColor: 'info.main',
          color: '#fff',
          '& .MuiChip-icon': { color: '#fff' },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
  );
};

export default UnitTag;
